import React, { useContext } from 'react';
import '../styles/basketItemDiscount.css';
import { LanguageContext } from '../context/language/LanguageContext';
import appConst from '../Utilities/appConst.json';

export default function SummaryBasketItemDiscountDetails(props) {
  const languageContext = useContext(LanguageContext);
  const detailsItemId = props.itemId ?? "unknown";

  return (
    <div className="summary_item_discount" data-testid={`summary-item-discount-${detailsItemId}`}>
      {props.discounts && <div className="summary_box_item" data-testid={`summary-item-discount-row-${detailsItemId}`}>
        <div className='box_item_r' >{languageContext.getTranslation(appConst.DISCOUNT_SALE)}:</div>
        <div className='box_item_l'>({parseFloat(props.discounts).toFixed(2)}-)₪</div>
      </div>}
    </div>
  )
}
